import React from 'react';
import { LogOut } from 'lucide-react';

/**
 * A persistent, floating Quick Exit button visible on every page.
 * Positioned bottom-left so it doesn't overlap the Ground-me FAB (right).
 * Hidden on print.
 */
export default function FloatingQuickExit() {
  const handleClick = () => {
    try {
      window.location.replace('https://www.bbc.co.uk/weather');
    } catch {
      window.location.href = 'https://www.bbc.co.uk/weather';
    }
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Quickly exit this site"
      data-testid="floating-quick-exit"
      className="tf-no-print fixed z-40 inline-flex items-center gap-2 px-4 py-3 rounded-full font-bold"
      style={{
        left: 16,
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 72px)',
        background: 'var(--tf-purple)',
        color: '#fff',
        border: 'none',
        boxShadow: '0 10px 28px rgba(139,123,177,0.35)',
        fontSize: 13.5,
        letterSpacing: '0.02em',
        cursor: 'pointer',
      }}
    >
      <LogOut size={16} strokeWidth={2.2} />
      <span>Exit Now</span>
    </button>
  );
}
